import template from './log-list.html';
import controller from './log-list.controller';

let logListComponent = {
  bindings: {},
  template,
  controller
};

export default logListComponent;


// WEBPACK FOOTER //
// ./client/app/components/faq/log-list.component.js